// extracted by mini-css-extract-plugin
module.exports = {"cell":"SummaryCell_cell__U2ghn","active":"SummaryCell_active__3hwu-","sleep":"SummaryCell_sleep__3YGrR","fallingAsleep":"SummaryCell_fallingAsleep__2eAdH"};